/** Шаблоны AI робота «Чатов» — ровно то, что отдают ручки `/api/chats/ai-templates`. */
import { apiFetch, query } from "@/lib/api";

export type AiFields = {
  /** Тип обращения (сценарий): zapis, oplata, … */
  type: string;
  question: string;
  /** Как ещё спрашивают — по фразе в строке. */
  examples: string;
  /** Не применять, если … — по условию в строке. */
  exclude: string;
  text: string;
  /** Запасной текст; пусто — нет. */
  alt: string;
  instruction: string;
  kb_question_id: number | null;
};

export type AiTemplate = AiFields & {
  id: number;
  version: number;
  type_label: string;
  archived: boolean;
  /** Метки, которые раскрывает модель (не метки кода). */
  model_marks: string[];
  /** Кто правил последним; `author_kind` model — первый набор от модели. */
  author: string;
  author_kind: string;
  at: string | null;
  /** За 30 дней: сколько черновиков по шаблону и чем кончились. */
  hits: number;
  sent: number;
  edited: number;
  rejected: number;
  deviated: number;
};

export type AiList = {
  templates: AiTemplate[];
  /** Сценарии: код → название. */
  types: Record<string, string>;
  code_marks: string[];
  cities: { id: number; name: string }[];
};

export type AiVersion = {
  number: number;
  action: string;
  action_label: string;
  author_kind: string;
  author: string;
  reason: string;
  at: string | null;
  fields: AiFields;
};

export type AiProbe = {
  template: { id: number; version: number; question: string } | null;
  /** Детектор выбрал именно этот шаблон (или несохранённую форму). */
  picked_this: boolean;
  type: string;
  type_label: string;
  type_why: string;
  line: string | null;
  action: string | null;
  text: string;
  why: string;
  error: string;
  cost: number | null;
};

const BASE = "/api/chats/ai-templates";
const post = <T>(path: string, body?: unknown) =>
  apiFetch<T>(path, { method: "POST", body: JSON.stringify(body ?? {}) });

export const loadAiTemplates = (archived: boolean) => apiFetch<AiList>(`${BASE}${query({ archived })}`);
export const createAiTemplate = (fields: AiFields & { reason: string }) => post<AiTemplate>(BASE, fields);
export const editAiTemplate = (id: number, fields: AiFields & { reason: string; version: number }) =>
  apiFetch<AiTemplate>(`${BASE}/${id}`, { method: "PUT", body: JSON.stringify(fields) });
export const archiveAiTemplate = (id: number, archive: boolean, version: number) =>
  post<AiTemplate>(`${BASE}/${id}/${archive ? "archive" : "restore"}`, { version });
export const loadAiVersions = (id: number) => apiFetch<AiVersion[]>(`${BASE}/${id}/versions`);
export const revertAiTemplate = (id: number, number: number, version: number) =>
  post<AiTemplate>(`${BASE}/${id}/versions/${number}/revert`, { version });
export const probeAiTemplate = (
  body: { text: string; city: number | null; template_id: number | null; draft: AiFields | null },
  signal?: AbortSignal,
) => apiFetch<AiProbe>(`${BASE}/probe`, { method: "POST", body: JSON.stringify(body), ...(signal ? { signal } : {}) });
